import { render, staticRenderFns } from "./quiuzQuestion.vue?vue&type=template&id=25108762&scoped=true"
import script from "./quiuzQuestion.vue?vue&type=script&lang=js"
export * from "./quiuzQuestion.vue?vue&type=script&lang=js"
import style0 from "./quiuzQuestion.vue?vue&type=style&index=0&id=25108762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25108762",
  null
  
)

export default component.exports